export { default as Color } from "./colors";
export { default as Align } from "./alignments";
export { default as Font } from "./fonts";
export { default as Shadow } from "./shadows";
export { default as Dimensions } from "./dimensions";
